module.exports = __webpack_public_path__ + "img/Truppführer_FüGeh.4d1e54c2.svg";